export const FACTOR_MODAL_SPLIT_MODE_LIST = [
    "motorizedPrivateTransport",
    "publicBus",
    "publicRail",
];
